export default __webpack_public_path__ + "static/media/zachet-msk.efeabf55.png";